import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import CollaborationPanel from '../components/CollaborationPanel';
import { collaborationEnabled } from '../hooks/useCollaborationAccess';
import ModalCompartilharLegado from './ModalCompartilharLegado';

export default function ModalCompartilhar(props) {
  return collaborationEnabled ? <ModalColaboracao {...props} /> : <ModalCompartilharLegado {...props} />;
}

function ModalColaboracao({ propriedade, user, onClose, onAtualizar, darkMode = false }) {
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const close = event => { if (event.key === 'Escape' && !document.querySelector('[data-collaboration-inner]')) onClose(); };
    window.addEventListener('keydown', close);
    return () => { document.body.style.overflow = previous; window.removeEventListener('keydown', close); };
  }, [onClose]);
  return createPortal(<div className="collaboration-overlay" onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
    <div className="collaboration-dialog" role="dialog" aria-modal="true" aria-label={`Compartilhar ${propriedade.nome}`}>
      <CollaborationPanel property={propriedade} user={user} onBack={onClose} onUpdated={onAtualizar} darkMode={darkMode} />
    </div>
  </div>, document.body);
}
